<template>
  <div></div>
</template>
<script>
  import Cookies from 'js-cookie'
  export default {
    name: 'notice',
    components: {},
    data() {
      return {
        timer: null
      }
    },
    destroyed() {
      if (this.timer) clearInterval(this.timer)
    },
    methods: {
      getNotice() {
        if (this.timer) clearInterval(this.timer)
        let num = parseInt(Cookies.get('NoticeTime'));
        let now = new Date().getTime()
        let second = (now - num) / 1000
        let timeOut = 1 * 60 * 60 // 秒 
        if (second > timeOut + 2) {
          Cookies.set('NoticeTime', new Date().getTime())
          this.getNotice()
          return
        }
        if (second > timeOut) {
          this.$notify({
            title: '温馨提示',
            message: '你已经工作1小时了，休息一下再继续吧！',
            type: 'warning',
            duration: 0,
            onClose: () => {
              this.getNotice()
            }
          })
          Cookies.set('NoticeTime', new Date().getTime())

        } else {
          this.timer = setInterval(() => {
            if (second > timeOut) second--
            else {
              this.getNotice()
            }
          }, 1000)
        }
      }
    },
    created() {
      this.getNotice()
    }
  }
</script>

<style>
</style>
